const max = (data: any, accessor = (d: any) => d) =>
  Array.isArray(data) ? Math.max(0, ...data.map(accessor).filter(Number.isFinite)) : undefined;

export default max;
